import { Tabs, DatePicker } from "antd";
import type { TabsProps } from "antd";
import Detailstable from "./Detailstable";
import dayjs from "dayjs";
import locale from "antd/es/date-picker/locale/zh_CN";
import "dayjs/locale/zh-cn";
import { useEffect, useState } from "react";
import "./index.less";

const { RangePicker } = DatePicker;

const Tables = ({
  curSegment,
  customerCode,
}: {
  curSegment: string;
  customerCode?: string;
}) => {
  const [pickerDate, setPickerDate] = useState<any>([]);

  useEffect(() => {
    const curDate = dayjs();
    const preDate = dayjs(curDate).subtract(365, "days");
    setPickerDate([preDate, curDate]);
  }, []);

  const handleChangeDate = (e: any, times: any) => {
    setPickerDate(e);
    // console.log(dayjs(e[0]).format("YYYYMM"));
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "应付明细",
      children: (
        <Detailstable
          curSegment={curSegment}
          customerCode={customerCode}
          pickerDate={pickerDate}
          type="1"
        />
      ),
    },
    {
      key: "2",
      label: "付款明细",
      children: (
        <Detailstable
          curSegment={curSegment}
          customerCode={customerCode}
          pickerDate={pickerDate}
          type="2"
        />
      ),
    },
  ];

  return (
    <>
      <h4>资金使用明细</h4>
      <RangePicker
        value={pickerDate}
        className="balance-time"
        locale={locale}
        picker="month"
        format="YYYY-MM"
        allowClear={false}
        onChange={handleChangeDate}
      />
      <Tabs className="balance-tabs" defaultActiveKey="1" items={items} />
    </>
  );
};

export default Tables;
